import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";

export default function PartnerSettingsPage() {
    const { api, user } = useAuth();
    const [data, setData] = useState(null);
    const [busy, setBusy] = useState(false);
    const [newUser, setNewUser] = useState({ full_name: "", email: "", role: "partner_member" });
    const [feedback, setFeedback] = useState(null);

    const refresh = () => api.get("/v2/partner/dashboard").then(r => setData(r.data)).catch(() => {});

    useEffect(() => { refresh(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

    const invite = async () => {
        setBusy(true); setFeedback(null);
        try {
            const r = await api.post("/v2/partner/users", newUser);
            setFeedback({ ok: true, msg: `Invited ${r.data.email} · temp password ${r.data.temp_password}` });
            setNewUser({ full_name: "", email: "", role: "partner_member" });
        } catch (e) {
            setFeedback({ ok: false, msg: e.response?.data?.detail || "Invite failed" });
        } finally { setBusy(false); }
    };

    if (!data) return <div className="text-gray-500 text-sm">Loading…</div>;
    const isOwner = user?.role === "partner_owner";

    return (
        <div data-testid="partner-settings-page">
            <div className="mb-8">
                <h1 className="text-3xl font-display font-bold text-white">Settings</h1>
                <p className="text-sm text-gray-500 mt-1">{data.partner.organization_name}</p>
            </div>

            <div className="bg-card border border-border/40 p-6 mb-6">
                <p className="text-xs uppercase tracking-wider text-gray-500 mb-3 font-body">Organization</p>
                <div className="grid grid-cols-2 gap-y-2 text-sm">
                    <span className="text-gray-500">Name</span><span className="text-white font-mono">{data.partner.organization_name}</span>
                    <span className="text-gray-500">Tier</span><span className="text-white font-mono">{data.partner.billing_tier}</span>
                    <span className="text-gray-500">Billing model</span><span className="text-white font-mono">{data.partner.billing_model}</span>
                    <span className="text-gray-500">Status</span><span className="text-emerald-300 font-mono">{data.partner.status}</span>
                </div>
            </div>

            {isOwner && (
                <div className="bg-card border border-border/40 p-6" data-testid="invite-partner-user">
                    <p className="text-xs uppercase tracking-wider text-gray-500 mb-3 font-body">Invite a partner user</p>
                    <div className="grid grid-cols-[1fr_1fr_1fr_140px] gap-3">
                        <input className="bg-muted border border-border/40 px-3 py-2 text-sm text-white" placeholder="Full name"
                            value={newUser.full_name} onChange={e => setNewUser({ ...newUser, full_name: e.target.value })} />
                        <input className="bg-muted border border-border/40 px-3 py-2 text-sm text-white" placeholder="Email" type="email"
                            value={newUser.email} onChange={e => setNewUser({ ...newUser, email: e.target.value })} />
                        <select className="bg-muted border border-border/40 px-3 py-2 text-sm text-white"
                            value={newUser.role} onChange={e => setNewUser({ ...newUser, role: e.target.value })}>
                            <option value="partner_member">Partner Member</option>
                            <option value="partner_owner">Partner Owner</option>
                        </select>
                        <button onClick={invite} disabled={busy || !newUser.email || !newUser.full_name}
                            className="bg-white text-black px-3 py-2 text-sm font-semibold disabled:opacity-40">
                            {busy ? "Inviting…" : "Invite"}
                        </button>
                    </div>
                    {feedback && (
                        <p className={`text-xs mt-3 ${feedback.ok ? "text-emerald-300" : "text-red-300"}`}>{feedback.msg}</p>
                    )}
                </div>
            )}
            {!isOwner && (
                <div className="bg-card border border-amber-500/30 p-4 text-xs text-amber-200">
                    Inviting partner users is restricted to partner owners.
                </div>
            )}
        </div>
    );
}
